var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-status"},[_c(_setup.HelperViewStatus,{staticClass:"modal-status__view",attrs:{"title":_vm.title,"description":_vm.description,"status":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }